import { mainBus } from "utils/bus";

export const onPlayingGif = ({ id }:{ id : string}) => {
  mainBus.emit("set_playing_gif", { id });
};

export const onFullScreen = ({ id, isForceFS }: { id: string; isForceFS?: boolean }) => {
  mainBus.emit("toggle_fullscreen", { id, isForceFS });
};
